import React, { lazy } from 'react';
import { registerReduxStore } from '@/core/store';
import { registerRoutes } from '@/core/routes';
import { registerNavigation } from '@/core/navigation';
import { TeamOutlined } from '@ant-design/icons';
import {actions as CustomerManagementActions} from '../BPManagement.redux';
import {reducers as CustomerManagementReducers} from '../BPManagement.redux';

const CustomerManagement = lazy(() => import('./CustomerManagementEntry'));
const CustomerManagementSearch = lazy(() => import('./CustomerManagementSearch'));

registerReduxStore('bp', CustomerManagementReducers, CustomerManagementActions);

registerRoutes([
	{
		path: '/customer-management',
		exact: true,
		render: <CustomerManagement mode="new" />,
		title: 'Business Partner Management: New',
		private: true,
		permissions: ['bp_add'],
	},
	{
		path: '/customer-management/edit/:cardCode',
		exact: true,
		render: <CustomerManagement mode="edit" />,
		title: 'Business Partner Management: Edit',
		private: true,
		permissions: ['bp_edit'],
	},
    {
		path: '/customer-management/search',
		exact: true,
		render: <CustomerManagementSearch />,
		title: 'Business Partner Management: Search',
		private: true,
		permissions: ['bp_edit'],
	},
]);

registerNavigation({
	title: 'Business Partners',
	permissions: ['bp_nav'],
	single: false,
	top: true,
	home: true,
	icon: <TeamOutlined />,
	children: [
		{
			title: 'New BP',
			url: '/customer-management',
			permissions: ['bp_add'],
		},
        {
			title: 'Search BP',
			url: '/customer-management/search',
			permissions: ['bp_edit'],
		},
	],
});
